import { css } from 'styled-components/macro';

export const svgStyles = css`
  height: 23px;
  width: 23px;
`;
